import React from 'react';
import { Image, Text, View } from 'react-native';
import { textPrimary_10_0, textPrimary_9_3, textSecondary_8_0 } from '../TextComponent/TextStyle';

const TransferAmountComponent = ({
  globJSON,
  simPlatform, source, txt0, txt1, txt2, isBlueBorder,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    box: {
      width: 200,
      height: 54,
      marginLeft: 20,
      marginRight: 20,
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      borderColor: colors.border_light_color,
      borderWidth: 0.6,
      backgroundColor: colors.app_background_color,
    },
    container: {
      marginTop: 8,
      width: 200,
      height: 54,
      marginLeft: 20,
      marginRight: 20,
      flexDirection: 'row',
      justifyContent: 'space-around',
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      borderColor: isBlueBorder ? colors.primary_cta_color : colors.border_light_color,
      borderWidth: 1,
      backgroundColor: colors.app_background_color,
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={{ margin: 10, flex: 1 }}>
        <Image
          fadeDuration={0}
          style={{ width: 28, height: 29 }}
          source={source}
        />
      </View>
      <View style={{ margin: 'auto', flex: 5 }}>
        <Text style={textPrimary_9_3(globJSON, simPlatform)}>{txt0}</Text>
        <Text style={textSecondary_8_0(globJSON, simPlatform)}>{txt1}</Text>
        <Text style={[textPrimary_10_0(globJSON, simPlatform), { marginTop: 3 }]}>{txt2}</Text>
      </View>
    </View>
  );
};
export default TransferAmountComponent;
